const smoothScroll = (filter = 'a[href*="#"]', offset = 100, speed = 100) => {
  if (typeof window !== 'undefined') {
    return require('smooth-scroll')(filter, {
      offset,
      speed,
      speedAsDuration: true,
    });
  }
  return null;
};

export default smoothScroll;
